import { styled } from "@styles";

export const Wrapper = styled.div`
  margin-top: 20px;
`;
